module.exports = __webpack_public_path__ + "static/FAQ-install3-c12d1ebaee3a5f13d1a4924020223fd3.jpg";